export default "__VITE_ASSET__321ab436__"